module.exports = __webpack_public_path__ + "img/IMG_1627_BlackMatted_MockedUp.0785ac0b.jpg";